export const BROKER_CODES = [
    'mirae',
    'samsung',
    'kiwoom',
    'toss',
    'nh',
    'kb',
    'korea',
    'shinhan',
    'hana',
    'kakao',
    'daesin',
    'hanwha',
    'meritz',
    'none',
] as const;

export const BROKER_NAME_MAP: Record<BrokerCode, string> = {
    mirae: '미래에셋증권',
    samsung: '삼성증권',
    kiwoom: '키움증권',
    toss: '토스증권',
    nh: 'NH투자증권',
    kb: 'KB증권',
    korea: '한국투자증권',
    shinhan: '신한투자증권',
    hana: '하나증권',
    kakao: '카카오페이증권',
    daesin: '대신증권',
    hanwha: '한화투자증권',
    meritz: '메리츠증권',
    none: '없음',
};

export type BrokerCode = (typeof BROKER_CODES)[number];
